import _ from 'lodash';
import appConfig from 'app-config';
import {MLProductCodeUtil } from 'ml-portals-util-js';
import paWizardConfig from '../../capabilities-react/gw-capability-policychange-pa-react/config/pa-policychange-wizard-config.json5';
import hoWizardConfig from '../../capabilities-react/gw-capability-policychange-ho-react/config/ho-wizard-config.json5';
import pupWizardConfig from '../../capabilities-react/gw-capability-policychange-pup-react/config/pup-wizard-config.json5';
import ampPaWizardConfig from '../../capabilities-react/gw-capability-policychange-pa-react/config/pa-amp-wizard-config.json5';
import ampHoWizardConfig from '../../capabilities-react/gw-capability-policychange-ho-react/config/ho-amp-wizard-config.json5';
import ampPupWizardConfig from '../../capabilities-react/gw-capability-policychange-pup-react/config/pup-amp-wizard-config.json5';

const isAmp = appConfig.portalCode === 'AMP';

const getWizardSteps = (productCode) => {
    const isPersonalAuto = MLProductCodeUtil.isPersonalAuto(productCode);
    const isHomeowners = MLProductCodeUtil.isHomeOwners(productCode);

    let wizardConfig;
    if (isAmp) {
        if (isPersonalAuto) {
            wizardConfig = ampPaWizardConfig;
        } else if (isHomeowners) {
            wizardConfig = ampHoWizardConfig;
        } else {
            wizardConfig = ampPupWizardConfig;
        }
    } else {
        // eslint-disable-next-line no-lonely-if
        if (isPersonalAuto) {
            wizardConfig = paWizardConfig;
        } else if (isHomeowners) {
            wizardConfig = hoWizardConfig;
        } else {
            wizardConfig = pupWizardConfig;
        }
    }
    return wizardConfig.steps;
}

/*
Undesired steps are:
 - Starting point steps that have not already been visited
 - Duplicated steps that are not the final instance of that step

Need to remove and re-add steps at later point if they appear more than once, so that they will keep their later position in the list
*/
const createNewDesiredSteps = (remSteps) => {
    const newSteps = [];
    remSteps.forEach((s) => {
        if (_.get(s, 'stepProps.isStartingPointML', false) && !s.visited) {
            return;
        }
        const indexOfExistingStep = newSteps.findIndex((existingStep) => existingStep.path === s.path);
        if (indexOfExistingStep !== -1) {
            newSteps.splice(indexOfExistingStep, 1);
        }
        newSteps.push(s);
    })
    return newSteps;
}

const updateAvailableSteps = (steps, currentStepIndex, changeNextSteps) => {
    const remainingSteps = steps.slice(currentStepIndex + 1, steps.length);
    const newSteps = createNewDesiredSteps(remainingSteps); 
    changeNextSteps(newSteps);
};

const needToSkip = (submissionVM, goNext) => {
    if (!submissionVM.value.stayOnStepML) {
        goNext();
        return true;
    }
};

/*
    Runs required step updates 
    Returns true if current page is going to be skipped
*/
const startingPointPageLoadIsSkipping = (submissionVM, goNext, steps, currentStepIndex, changeNextSteps) => {
    if (!needToSkip(submissionVM, goNext)) {
        updateAvailableSteps(steps, currentStepIndex, changeNextSteps);
        return false;
    }
    return true;
};

// Add the new step into current steps array.
// Insert step at 0 as we want to keep additional changes last
const addAndNavigateToNewStep = (newStep, currentSteps, currentStepIndex, changeNextSteps, goNext) => {
    const newSteps = currentSteps.slice(currentStepIndex, currentSteps.length);
    newSteps.splice(0, 0, newStep);
    changeNextSteps(newSteps);
    goNext();
}

// Find the step from wizard config using step ID and add it into current steps.
const addAndNavigateToSelectedStep = (newStepID, currentSteps, currentStepIndex, changeNextSteps, goNext, productCode) => {
    const steps = getWizardSteps(productCode);
    const newStep = steps.find((step) => step.id === newStepID);
    addAndNavigateToNewStep(newStep, currentSteps, currentStepIndex, changeNextSteps, goNext);
}

const findStepAndChangeNextStep = (productCode, mlStepNameSearch, changeNextSteps) => {
    const steps = getWizardSteps(productCode);
    const index = _.findIndex(steps, ({ mlStepName }) => mlStepName === mlStepNameSearch);
    if (index > 0) {
        const remainingSteps = steps.slice(index, steps.length);
        changeNextSteps(remainingSteps);
    }
}

export default {
    startingPointPageLoadIsSkipping,
    updateAvailableSteps,
    needToSkip,
    addAndNavigateToSelectedStep,
    addAndNavigateToNewStep,
    findStepAndChangeNextStep
};